import React, { useEffect, useState } from "react";
import { Modal, Rate, Button } from "antd";
import Main from "../../components/layout/Main";
import { X } from "lucide-react";
import TrofiIcon from "../../assets/images/trofies-image.svg";
import CollectibleIcon from "../../assets/images/trofies-image.svg";
import ProfileIcon from "../../assets/images/trofies-image.svg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  DEFAULT_PAGE,
  DEFAULT_LIMIT,
  isScrollAtBottom,
  isValidUrl,
  getDifference,
} from "../../helper/functions";

const NotificationsIndex = () => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const { getNotification } = useAuth();
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [hasMore, setHasMore] = useState(true);
  const limit = DEFAULT_LIMIT;
  // ---------- Use Effect ----------
  const fetchNotification = async (reset = false) => {
    try {
      const response = await getNotification({ page, limit });
      if (response.status === 200) {
        if (reset) {
          setNotifications(response.data.data.data);
        } else {
          setNotifications((prev) => [...prev, ...response.data.data.data]);
        }
      }
    } catch (error) {
      console.log("Error--->", error);
    }
  };

  // const handleRedirectNotification = async (action) => {
  //   try {
  //     let screen = action.screen.toLowerCase();
  //     switch (screen) {
  //       case "profile": {
  //         navigate(`/profile/${action.params.userId}`);
  //         break;
  //       }
  //       case "wallet": {
  //         navigate(`/wallet`);
  //         break;
  //       }
  //       default: {
  //         if (!screen) {
  //           return navigate(`/home`);
  //         }
  //         navigate(`/${screen}`);
  //         break;
  //       }
  //     }
  //     return;
  //   } catch (error) {
  //     console.log("Error occured while redirect notification", error);
  //   }
  // };

  const handleScroll = (e) => {
    if (isScrollAtBottom(e) && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, []);

  useEffect(() => {
    setPage(DEFAULT_PAGE);
    setHasMore(true);
    fetchNotification(true);
  }, []);

  useEffect(() => {
    if (page > 1) {
      fetchNotification();
    }
  }, [page]);

  return (
    <>
      <Main>
        <div className="notification-section section-main ">
          <div className="notifications-headding">
            <div className="orange-header">Notifications</div>
            <p>
              Here you’ll find all your recent activity, alerts, and important
              updates.
            </p>
          </div>
          <div className="notification-listbar">
            {/* <h6 className="list-notification-head">Today</h6> */}
            <div
              className="notification-grid-list notification-main-list"
              onScroll={handleScroll}
            >
              {notifications &&
                notifications.map((notification, index) => {
                  return (
                    <div
                      className="notification-card"
                      key={index}
                      // onClick={() =>
                      //   handleRedirectNotification(notification.action)
                      // }
                    >
                      <div className="notification-icon">
                        <img
                          alt="icon"
                          src={
                            isValidUrl(notification?.image)
                              ? notification.image
                              : TrofiIcon
                          }
                          // src={TrofiIcon}
                        />
                      </div>
                      <div className="notification-card-text">
                        <h6>{notification?.message}</h6>
                        <p>{getDifference(notification?.created_at)}</p>
                      </div>
                      <div className="notification-close">
                        <Button className="close-icon">
                          <X />
                        </Button>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          {/* <div className="notification-listbar">
            <h6 className="list-notification-head">Earlier</h6>
            <div className="notification-grid-list">
              <div className="notification-card">
                <div className="notification-icon">
                  <img alt="icon" src={ProfileIcon} />
                </div>
                <div className="notification-card-text">
                  <h6>@gaming_pro started following you</h6>
                  <p>2 days ago</p>
                </div>
                <div className="notification-close">
                  <Button className="close-icon">
                    <X />
                  </Button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </Main>
    </>
  );
};

export default NotificationsIndex;
